(function (angular, app) {
    'use strict';

    app.service('LastMinuteRecommendationsDialog', ['mDesign', function(mDesign) {
        this.show = show;
        this.hide = hide;

        function show(lastMinuteRecommendations, goToCheckoutCallback) {
            return mDesign.dialog({
                templateUrl: 'views/templates/last-minute-recommendations.html',
                controller: 'LastMinuteRecommendationsCtrl as lastMinuteRecommendationsCtrl',
                multiple: true,
                clickOutsideToClose: false,
                locals: {
                    lastMinuteRecommendations: lastMinuteRecommendations,
                    goToCheckoutCallback: goToCheckoutCallback
                }
            });
        }

        function hide() {
            mDesign.hide();
        }
    }]);

    app.run(['$rootScope', 'LastMinuteRecommendationsDialog', function ($rootScope, LastMinuteRecommendationsDialog) {
        $rootScope.LastMinuteRecommendationsDialog = LastMinuteRecommendationsDialog;
    }]);

    app.controller('LastMinuteRecommendationsCtrl', [
        '$scope', '$rootScope', '$state', '$anchorScroll', 'Config', 'User', 'CouponDetailsDialog', 
        'SpecialDetailsDialog', 'lastMinuteRecommendations', 'goToCheckoutCallback', 'Util', 'Cart', 
        'SP_SERVICES','mDesign', 'DELIVERY_MODE_TOGGLE', 'spSpecialTypeChecker',
        function ($scope, $rootScope, $state, $anchorScroll, Config, User, CouponDetailsDialog, 
            SpecialDetailsDialog, lastMinuteRecommendations, goToCheckoutCallback, Util, Cart, 
            SP_SERVICES, mDesign, DELIVERY_MODE_TOGGLE, spSpecialTypeChecker) {
            var lastMinuteRecommendationsCtrl = this,
                LOYALTY_PREMIUM_PACKAGE = 16,
                _LMRData = null,
                _listeners = [];
                var lmRTranslations = lastMinuteRecommendations.settings.translations[$rootScope.config.language.id];
            lastMinuteRecommendations.settings.sections.forEach(function(section) {
                section.start = section.sectionType === $rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.TIP_DONATION || section.sectionType === $rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.COUPONS ? 2 : 3;
                switch(section.sectionType) {
                    case $rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.OFFERS:
                        section.componentType =(lmRTranslations && lmRTranslations.titleSpecialsOffers) || $rootScope.$filter('translate')('last_minute_recommendations_title_specials_offers');
                        break;
                    case $rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.PRODUCTS_USUALLY:
                        section.componentType =(lmRTranslations && lmRTranslations.titleProductsUsually) || $rootScope.$filter('translate')('last_minute_recommendations_title_products_usually');
                        break;
                    case $rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.PRODUCTS_COMPLEMENTARY:
                        section.componentType =(lmRTranslations && lmRTranslations.titleProductsComplementary) || $rootScope.$filter('translate')('last_minute_recommendations_title_products_complementary');
                        break;
                    case $rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.COUPONS:
                        section.componentType =(lmRTranslations && lmRTranslations.titleCoupons) || $rootScope.$filter('translate')('last_minute_recommendations_title_coupons');
                        break;
                    case $rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.TIP_DONATION:
                        section.componentType =(lmRTranslations && lmRTranslations.titleTipDonation) || $rootScope.$filter('translate')('last_minute_recommendations_title_tip_donation');
                        break;
                    default:
                        section.componentType = '';
                        break;
                }
            });
            angular.extend(lastMinuteRecommendationsCtrl, {
                LMRSettings: lastMinuteRecommendations.settings,
                itemLimitExceededWarning : {},
                isActiveMobileExpress : false,
                itemLimitExceededMessageAtCheckout : {},
                isActiveProductLimitInCart : false,
                isSwitchToDelivery: false,
                isAreaSupportExpressDelivery : localStorage.getItem('mobileZuzAreaSupportedExpressDelivery') === 'true',
                LMRData: _getLastMinuteRecommendationsData(),
                goToSection: $anchorScroll,
                deliveryTypeId: Config.getBranchArea() && Config.getBranchArea().deliveryTypeId,
                branchArea: Config.getBranchArea(),
                toggleView: toggleView,
                goToSpecial: goToSpecial,
                goToCheckout: goToCheckout,
                closeDialog: closeDialog
            });

            Config.waitForInit().then(function () {
                if(Config.retailer.settings){
                    lastMinuteRecommendationsCtrl.itemLimitExceededWarning = Util.tryParseJson(Config.retailer.settings.productLimitInCart) &&  Util.tryParseJson(Config.retailer.settings.productLimitInCart).itemLimitExceededWarning || {};
                    lastMinuteRecommendationsCtrl.isActiveMobileExpress = Util.tryParseJson(Config.retailer.settings.mobileExpressDelivery) &&  Util.tryParseJson(Config.retailer.settings.mobileExpressDelivery).isActive || false;
                    lastMinuteRecommendationsCtrl.itemLimitExceededMessageAtCheckout = Util.tryParseJson(Config.retailer.settings.productLimitInCart) && Util.tryParseJson(Config.retailer.settings.productLimitInCart).itemLimitExceededMessageAtCheckout || {};
                    lastMinuteRecommendationsCtrl.isActiveProductLimitInCart = Util.tryParseJson(Config.retailer.settings.productLimitInCart) && Util.tryParseJson(Config.retailer.settings.productLimitInCart).isActive || false;
                }
            });

            User.getUserSettings().then(function(user) {
                lastMinuteRecommendationsCtrl.user = user;
            });

            $scope.goToCoupon = function(coupon, terms) {
                CouponDetailsDialog.show(coupon, terms);
            }

            $scope.isEmptyObjectWithDelivery = function () {
               return Util.isEmptyObjectWithDelivery($rootScope.cart.lines);
            }
            lastMinuteRecommendationsCtrl.isLoyaltyPackageEnabled = Config.retailer.premiumFeaturesEnabled.includes(LOYALTY_PREMIUM_PACKAGE);
            lastMinuteRecommendationsCtrl.userCashbackLoyalty = Util.findUserCashbackLoyaltyClub()
            if(lastMinuteRecommendationsCtrl.userCashbackLoyalty) {
                _setCashbackLoyaltyClub(lastMinuteRecommendationsCtrl.userCashbackLoyalty.loyaltyClubId);
            }

            if(lastMinuteRecommendationsCtrl.activeCashbackLoyalty) {
                Util.getUserCashbackPoints(lastMinuteRecommendationsCtrl.userCashbackLoyalty.id).then(function (response) {
                    lastMinuteRecommendationsCtrl.userCashbackLoyalty.points = response.points || 0;
                });
            }

            function toggleView($event, product) {
                product.editState = !product.editState;
                $event && $event.preventDefault();
                lastMinuteRecommendations.data[$rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.PRODUCTS_COMPLEMENTARY].forEach(function (prod) {
                    if (prod.editState && prod !== product) {
                        prod.editState = false;
                    }
                });
            }

            function goToSpecial(offer, index) {
                if (offer.item) {
                    Util.goToProductDialog(offer.item);
                } else {
                    // Emit ECOM-17455 Special Selected event
                    var specialInfo = _getSpecialInfoToTrack(offer, index);
                    $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_SPECIAL_SELECTED, specialInfo);
                    
                    if (Config.retailer.settings.isNewPromotionDesignEnabled === 'true') {
                        // ECOM-17470 Click & Save Selected - Save to localStorage
                        $rootScope.spMixPanel.trackPreviousProperties({
                            [$rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_CLICK_SAVE_SELECTED]: {
                            specialId: offer.id,
                            productId: offer && offer.item ? offer.item.id : null,
                        }});
                        
                        SpecialDetailsDialog.show(offer.id);
                    } else {
                        $state.go('app.specials.special', {ssid: offer.id});
                    }
                }
            }

            function _showLimitExceedWarning(){
                return mDesign.dialog({
                    templateUrl: 'views/templates/express-delivery/limit-exceed-pop-up.html',
                    controller: 'LimitExceedWarningCtrl',
                    controllerAs: 'limitExceedWarningCtrl',
                    clickOutsideToClose: false,
                    locals: {
                        isShowSwitchToScheduledDelivery: true,
                    }
                });
            }

            function _shouldShowLimitExceedWarnig() {
                var modeToggleDelivery = localStorage.getItem('mobileZuzModeToggle') || DELIVERY_MODE_TOGGLE.SCHEDULED_DELIVERY_PICKUP;
                var isCheckTotalCart = lastMinuteRecommendationsCtrl.isActiveMobileExpress && lastMinuteRecommendationsCtrl.isActiveProductLimitInCart;
                var isTotalLinesExceedWarning = lastMinuteRecommendationsCtrl.itemLimitExceededWarning.maxProduct && Cart.totalLinesWithoutCoupon() > lastMinuteRecommendationsCtrl.itemLimitExceededWarning.maxProduct;
                return isCheckTotalCart && isTotalLinesExceedWarning && 
                Number(modeToggleDelivery) === DELIVERY_MODE_TOGGLE.EXPRESS_DELIVERY && !lastMinuteRecommendationsCtrl.isSwitchToDelivery && lastMinuteRecommendationsCtrl.isAreaSupportExpressDelivery;
            }

            function goToCheckout(event) {
                if (_shouldShowLimitExceedWarnig()) {
                    _showLimitExceedWarning().then(function (result) {
                        if (result && result.isSwitchToDelivery) {
                            lastMinuteRecommendationsCtrl.isSwitchToDelivery = result.isSwitchToDelivery;
                            lastMinuteRecommendationsCtrl.goToCheckout(event);
                        }
                        else if (result && result.isChangeExpressDelivery) {
                            lastMinuteRecommendationsCtrl.closeDialog();
                        }
                    });
                    return;
                }
                lastMinuteRecommendationsCtrl.closeDialog();
                goToCheckoutCallback(event, true);
            }

            function closeDialog() {
                $rootScope.LastMinuteRecommendationsDialog.hide();
            }

            // Add function to track LMS product clicks
            lastMinuteRecommendationsCtrl.trackProductClick = function(product, carouselType, position) {
                // LMS product click tracking is now handled directly in mixPanel.js
            };

            function _setCashbackLoyaltyClub(loyaltyClubId) {
                angular.forEach(Config.retailer.loyaltyClubDrivers, function (loyaltyClubDriver) {
                    if(loyaltyClubDriver.clientConfig.loyaltyClubs && loyaltyClubDriver.clientConfig.loyaltyClubs[loyaltyClubId] &&
                        loyaltyClubDriver.clientConfig.loyaltyClubs[loyaltyClubId].pointsToCashback) {
                        lastMinuteRecommendationsCtrl.activeCashbackLoyalty = loyaltyClubDriver.clientConfig.loyaltyClubs[loyaltyClubId];
                    }
                });
            }

            function _getLastMinuteRecommendationsData() {
                if(_LMRData) {
                    return _LMRData;
                }
                _setSoldBy(lastMinuteRecommendations);
                var branchArea = Config.getBranchArea();
                var tipDonationProducts = lastMinuteRecommendations.data[$rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.TIP_DONATION];
                var allowedDeliveryTypes = [$rootScope.SP_SERVICES.DELIVERY_TYPES.DELIVERY, $rootScope.SP_SERVICES.DELIVERY_TYPES.EXPRESS_DELIVERY];

                if (branchArea && !allowedDeliveryTypes.includes(branchArea.deliveryTypeId) && lastMinuteRecommendations.settings.config.hideTipsCarouselOnPickUp === 'true' && tipDonationProducts && tipDonationProducts.length > 0) {
                    var productsToFilter = new Set(tipDonationProducts.map(function(product) {
                        return product.id
                    }));
                    var sectionsToCheck = [$rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.PRODUCTS_COMPLEMENTARY, $rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.OFFERS, $rootScope.LAST_MINUTE_RECOMMENDATIONS.SECTIONS_TYPES.PRODUCTS_USUALLY].filter(function(section) {
                        return lastMinuteRecommendations.data.hasOwnProperty(section)
                    });

                    sectionsToCheck.forEach(function(section) {
                        lastMinuteRecommendations.data[section] = lastMinuteRecommendations.data[section].filter(function(product) {
                            return !productsToFilter.has(product.id)
                        });
                    });
                }

                Object.values(lastMinuteRecommendations.data).forEach(function(section) {
                    User.injectSuggestionsForProducts(section);
                })
                var lmsTotalLines = 0;
                // Filter out-of-stock
                Object.keys(lastMinuteRecommendations.data).forEach(function(sectionKey) {
                    lastMinuteRecommendations.data[sectionKey] = lastMinuteRecommendations.data[sectionKey].filter(function(product) {
                        var branch = product.branch;
                        // Keep if `isOutOfStock` is undefined, or explicitly false
                        return !branch || typeof branch.isOutOfStock === 'undefined' || branch.isOutOfStock === false;                    
                    });
                    lmsTotalLines += lastMinuteRecommendations.data[sectionKey].length;
                });
                $rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_LMS_SUGGESTIONS_VIEWED, {
                    totalLines: lmsTotalLines
                });
                _LMRData = lastMinuteRecommendations.data;
                return lastMinuteRecommendations.data;
            }

            function _setSoldBy(lastMinuteRecommendations) {
                angular.forEach(lastMinuteRecommendations.data , function(items) {
                    angular.forEach(items, function (item) {
                        item.soldBy = null;
                        if (Util.isUnitsWeighable(item)) {
                            var cartLine = _getLine(item);
                            if (!cartLine) {
                                var soldBy;
                                if (!!item.productDisplayModeId) {
                                    switch (item.productDisplayModeId) {
                                        case $rootScope.PRODUCT_DISPLAY.UNIT.id:
                                            soldBy = $rootScope.PRODUCT_DISPLAY.UNIT.name;
                                            break;
                                        case $rootScope.PRODUCT_DISPLAY.WEIGHT.id:
                                            soldBy = $rootScope.PRODUCT_DISPLAY.WEIGHT.name;
                                            break;
                                        default:
                                            soldBy = item.isWeighable ? (item.weight ? $rootScope.PRODUCT_DISPLAY.UNIT.name : $rootScope.PRODUCT_DISPLAY.WEIGHT.name) : null;
                                    } 
                                } else {
                                    soldBy = item.isWeighable ? (item.weight ? $rootScope.PRODUCT_DISPLAY.UNIT.name : $rootScope.PRODUCT_DISPLAY.WEIGHT.name) : null;
                                }
                                item.soldBy = soldBy;
                            } else {
                                item.soldBy = cartLine.soldBy;
                            }
                        }
                    })
                });
            }

            function _getLine(product) {
                var cartLines = Cart.getLines(),
                    cartLine;
                if (!cartLines) return;
                angular.forEach(cartLines, function (line) {
                    if (line.product && line.product.id === product.id) {
                        cartLine = line;
                    }
                })
                return cartLine;
            }

            function _getSpecialInfoToTrack(special, index) {
                var specialInfo = {
                    promotionId: special.id,
                    promotionType: SP_SERVICES.MIXPANEL_VALUES.UNKNOWN,
                    specialPosition: SP_SERVICES.MIXPANEL_VALUES.UNKNOWN,
                    source: SP_SERVICES.SOURCES.CART_SUMMARY,
                }

                if (special && index > -1) {
                    specialInfo.promotionType = spSpecialTypeChecker.getSpecialType(special);
                    specialInfo.specialPosition = SP_SERVICES.SOURCES.LAST_RECOMMENDATIONS.LIST_NAME + ' - ' 
                                                + SP_SERVICES.SOURCES.LAST_RECOMMENDATIONS.SECTIONS_TYPES.PRODUCTS_COMPLEMENTARY 
                                                + ' At Position ' + (index + 1).toString();
                }

                return specialInfo;
            }

            Util.destroyListeners($rootScope, _listeners);

        }]);
})(angular, angular.module('mobilezuz'));
